"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var CloseIcon_1 = __importDefault(require("../../app/components/widgets/CloseIcon"));
var constants_1 = require("../constants");
var useStyles = (0, core_1.makeStyles)(function (theme) {
    return (0, core_1.createStyles)({
        tag: {
            display: 'flex',
            alignItems: 'center',
            backgroundColor: theme.palette.secondary.main,
            borderRadius: 5,
            minHeight: constants_1.TEXT_FIELD_HEIGHT - theme.spacing(2),
            margin: theme.spacing(1, 0, 1, 1),
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(0.75),
        },
        tagText: {
            color: '#FFFFFF',
            fontSize: '14px',
            marginRight: theme.spacing(0.75),
        },
        tagButton: {
            padding: 0,
        },
    });
});
function FormTag(_a) {
    var tag = _a.tag, onClose = _a.onClose;
    var classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.tag },
        react_1.default.createElement(core_1.Typography, { className: classes.tagText }, tag),
        react_1.default.createElement(core_1.IconButton, { className: classes.tagButton, size: "small", onClick: onClose },
            react_1.default.createElement(CloseIcon_1.default, { size: 10, color: "#FFFFFF" }))));
}
exports.default = FormTag;
